<template>
  <ElForm
    class="step-one-form form"
    ref="propertyFormRef"
    :rules="rules"
    :model="propertyForm"
  >
    <TabList
      class="step-one-form__tabs"
      :objects="objects"
      @tab-click="tabClickHandler"
    />
    <div class="step-one-form__item form__item">

    <div class="step-one-form__item form__item" style="flex-direction: column;width: calc(50% - 8px);">
      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="bank"
      >
        <ElAutocomplete
          class="step-one-form__autocompleate"
          v-model="bank"
          placeholder="Банк кредитор"
          :fetch-suggestions="querySearchBank"
          :popper-append-to-body="false"
          @select="(item) => formSelectHandler(item, 'bank')"
          @input="() => propertyForm.bank = ''"
        >
          <template #prefix>
            Банк кредитор
          </template>

          <template slot-scope="{ item }">
            <div class="step-one-form__autocompleate-option">
              <img v-if="item.iconPath" class="step-one-form__autocompleate-option-icon" :src="item.iconPath" alt="">

              <div class="step-one-form__autocompleate-option-value">{{ item.value }}</div>
            </div>
          </template>

          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElAutocomplete>
      </ElFormItem>
    
      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="credit_balance"
      >
        <ElInput
          v-model="propertyForm.credit_balance"
          placeholder="Остаток кредита"
          @input="formatMoney"
        >
          <template #prefix>
            Остаток кредита
          </template>

          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElInput>
      </ElFormItem>
    </div>
    <div class="step-one-form__item form__item" style="flex-direction: column;width: calc(50% - 8px);">

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="birth_date"
      >
        <ElDatePicker
          v-model="propertyForm.birth_date"
          v-mask="{mask: '9{2}.9{2}.9{4}'}"
          ref="birthPicker"
          type="date"
          placeholder="дд.мм.гггг"
          :default-value="subYears(new Date(), 18)"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          :picker-options="{ disabledDate: (time) => disableInvalidBirthDates(time), firstDayOfWeek: 1 }"
        />

        <span class="form__label">Дата рождения</span>
      </ElFormItem>

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="gender"
      >
        <ElSelect
          v-model="propertyForm.gender"
          placeholder="Пол"
          :popper-append-to-body="false"
          @change="(item) => formSelectHandler(item, 'gender')"
          @blur="genderBlurHandler"
        >
          <template #prefix>
            Пол
          </template>

          <ElOption
            v-for="(option, index) in genders"
            :key="index"
            :label="option.label"
            :value="option.value"
          >
          </ElOption>
        </ElSelect>
      </ElFormItem>
    </div>
  </div>


    <div class="step-one-form__buttons form__buttons">
      <BaseButton
        class="step-one-form__buttons-item"
        text="Рассчитать стоимость"
        size="large"
        @click.native="submitHandler($refs.propertyFormRef)"
      />
    </div>
  </ElForm>
  
</template>

<script>
import { subYears } from 'date-fns';
import { calculatorEipoteka } from '@/api/routes/calculator-eipoteka';
import TabList from '@/components/shared/tabs/TabList';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'Step1',
  components: {
    BaseButton,
    TabList,
  },
  props: {
    resultId: Number,
    bankStringCode: String,
  },
  data() {
    return {
      bank: '',
      propertyForm: {
        bank: null,
        credit_balance: '',
        birth_date: '',
        gender: '',
        objectId: '',
      },
      objects: [],
      rules: {
        bank: [
          { required: true, message: 'Поле банка кредитора обязательно для заполнения', trigger: 'blur' },
        ],
        credit_balance: [
          { required: true, message: 'Поле остатка кредита обязательно для заполнения', trigger: 'blur' },
        ],
        birth_date: [
          { required: true, message: 'Поле даты рождения обязательно для заполнения', trigger: 'blur' },
        ],
        gender: [
          { required: true, message: 'Поле пол обязательно для заполнения', trigger: 'blur' },
        ],
      },
      genders: [{
        value: 'M',
        label: 'мужской'
      }, {
        value: 'F',
        label: 'женский'
      }],
      banks: [],
      stepOneSessionData: null,
    }
  },
  computed: {
    isCreditDateVisible() {
      return this.propertyForm?.bank?.useCreditDate;
    },
  },
  methods: {
    setBankQuery() {
      if (!this.bankStringCode) {
        return;
      }

      if (
        !this.banks
        || this.banks.length <= 0
      ) {
        return;
      }

      const _this = this;

      this.banks.forEach(function (bank) {
        if (
          bank?.code
          && bank.code === _this.bankStringCode
        ) {
          _this.propertyForm.bank = bank;
          _this.bank = bank?.name ?? '';
        }
      });
    },
    formatMoney() {
      let rawValue = this.propertyForm.credit_balance.replace(/[^0-9.]/g, '');

      const parts = rawValue.split('.');
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      let decimalPart = parts[1] ? '.' + parts[1].slice(0, 2) : '';

      if (rawValue.includes('.') && !!!decimalPart) {
        decimalPart = '.';
      }

      this.propertyForm.credit_balance = integerPart + decimalPart;
    },
    tabClickHandler(dataTabs) {
      this.objects = dataTabs;

      this.setActiveTab();
    },
    setActiveTab() {
      this.propertyForm.objectId = this.objects.find((tab) => tab.isActive)?.objectId;
    },
    formSelectHandler(data, formField) {
      this.propertyForm[formField] = data;

      this.$refs.propertyFormRef.validateField(formField);
    },
    querySearchBank(queryString, cb) {
      const banks = this.banks;
      const results = queryString ? banks.filter(this.createFilterInclude(queryString)) : banks;

      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    createFilterInclude(queryString) {
      return (link) => {
        return link.value.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    disableInvalidBirthDates(birthDate) {
      const currentDate = new Date();
      const eighteenYearsAgo = subYears(currentDate, 18);

      return birthDate.getTime() > eighteenYearsAgo.getTime();
    },
    genderBlurHandler() {
      this.$refs.propertyFormRef.validateField('gender');
    },
    async loadSelectOptions(action) {
      const responseData = await calculatorEipoteka(action);

      if (!responseData.result) {
        return [];
      }

      const array = responseData.response;

      return array.map((item) => ({
        ...item,
        value: item.name,
      }));
    },
    restoringForm(prevFormData) {
      this.propertyForm = prevFormData;
      this.bank = prevFormData.bank.name;

      this.objects = this.objects.map((object) => ({
        ...object,
        isActive: object.objectId === prevFormData.objectId,
      }))
    },
    submitHandler(formEl) {
      formEl.validate(valid => {
        if (valid) {
          this.$emit('step-one-submit', this.propertyForm, this.stepOneSessionData);
        }
      });
    },
    subYears,
  },
  async mounted() {
    const objectsResponseData = await calculatorEipoteka('getObjectsAction');

    if (!objectsResponseData.result) {
      this.objects = []
    } else {
      this.objects = objectsResponseData.response;
    }

    this.banks = await this.loadSelectOptions('getBanksAction');
    

    this.stepOneSessionData = await calculatorEipoteka('getSessionData');
    if (!!!this.resultId) {
      this.resultId = this.stepOneSessionData.resultId ?? 0;
    }
    this.$emit('update-result-id', this.resultId);

    if (this.stepOneSessionData && this.stepOneSessionData.stepOne) {
      this.restoringForm(this.stepOneSessionData.stepOne);
    } else if (objectsResponseData.result) {
      this.objects[0].isActive = true;
      this.objects = [...this.objects]
    }
    this.setActiveTab();
    this.setBankQuery();
  },
}
</script>

<style lang="scss" scoped>
.form{
  &__item {
    margin-top: 0px !important;
  }
}
.step-one-form {
  max-width: 700px;
  &__tabs {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
    @media #{$screen-small} {
        flex-direction: column;
        width: 100% !important;
    }
  }

  &__item {
    display: flex;
    flex-wrap: wrap;
    gap: rem(16);

    &-col {

      @media #{$screen-big} {
      }

      @media #{$screen-small} {
        width: 100%;
      }
    }
  }

  &__buttons {
    justify-content: flex-end;

    margin-top: rem(24);

    &-item {
      width: calc(50% - 8px);

      @media #{$screen-big} {
      }

      @media #{$screen-small} {
        width: 100%;
      }
    }
  }

  &__autocompleate {
    &-option {
      display: flex;
      align-items: center;
      gap: rem(16);

      &-icon {
        width: rem(32);
        height: rem(32);

        object-fit: contain;
        border-radius: rem(5);
      }

      &-value {
        @include text-props(16, 20.8);
      }
    }
  }
}
</style>

